import React, { useState } from "react";
import TooltipTrigger from "../bootstrap/TooltipTrigger";
import UserCard from "./UserCard";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

export default function AuthorSideBar(props) {
    let {
        review,
        product,
        includePeerTalk=true,
        includeProductVerification=true,
        gtmEventRegion='peer-research-single-review',
        gtmEventElement='reviewers-profile',
        extraData={},
        modalOverlay=false,
        registrationFor='PeerSpot',
        toggleRegistration=()=>{},
        tooltips
    } = props;

    const renderProductVerification = () => {
        if(includeProductVerification) {
            return (
                <div className={'text-secondary'}>Verified user of {product.name}
                    <TooltipTrigger id={`pu-tt_${review.author.id}`} placement={'bottom'} content={review.author.label_tooltip}>
                        <i className={'fal fa-question-circle font-12 text-blue-link ps-1'} />
                    </TooltipTrigger>
                </div>
            )
        }
    }

    const renderSubmittedViaAws = () => {
        if(review.source?.startsWith('partner_aws')) {
            return (<div className={'text-secondary'}>Submitted via the AWS Marketplace</div>)
        }
    }

    const renderIncentivized = () => {
        if(review.incentive_id) {
            return (
                <div className={'text-secondary'}>This user was compensated for their interview
                    <TooltipTrigger placement='bottom' content={tooltips.incentive}>
                        <i className={'fal fa-question-circle fs-6 text-blue-link ps-1'}/>
                    </TooltipTrigger>
                </div>
            )
        }
    }

    const renderInquiryCall = () => {
        if(includePeerTalk) {
            return (
                <div className={'my-2'}>
                    <Button
                        data-gtm-event-region={'peer-research-single-review'}
                        data-gtm-event-element={'request-call'}
                        variant={'primary'}
                        size={'sm'}
                        className={'btn-block px-1'}
                        onClick={(e) => toggleRegistration({
                            leadCode: 'INQUIRY_CALL',
                            includePeerTalk: true,
                            cta: `Request a call with ${review.author.username}`,
                            modalHeader: `Get full access to ${registrationFor}`,
                            modalSubheader: `Register to unlock all ${registrationFor} features`,
                            modalOverlay: modalOverlay,
                            gtmEventRegion: props.gtmEventRegion,
                            gtmEventElement: 'request-call',
                            actionParams: {
                                product: {
                                id: product.id,
                                name: product.name,
                                category: { id: product.category.id },
                                smarter_questions: product?.smarter_questions
                            },
                                smarter_questions: extraData.smarter_questions,
                                selected: { ...review.author, industry: review.author.industry, job_function: review.author.job_function},
                            },
                            confirmationParams: {
                                header: 'Thank you',
                                subHeader: 'Your request has been sent successfully. We will contact the peer to coordinate the call and get back to you.' },
                            hiddenTags: {
                                ...review.lead_gen_attributes, todo: 'inquiry_call', itemid: review.author.id, 'lead[lead_code]': 'INQUIRY_CALL' }
                        })}>
                        {`Request a call with ${review.author.username}`}
                    </Button>
                </div>
            )
        }
    }

    return (
        <Card className={'shadow-none px-3 py-2'}>
            <div data-gtm-event-region={gtmEventRegion} data-gtm-event-element={gtmEventElement}>
                <UserCard user={review.author}  verifiedAvatar={true} />
            </div>
            {renderInquiryCall()}
            {renderProductVerification()}
            {renderIncentivized()}
            {renderSubmittedViaAws()}
        </Card>
    )
}